import { BooleanValues, DraggableFilterType } from '../../../../../../constants';
import { Base, ControlProperty, COUNTRIES } from '../../../../../../../common';
import { UserOwnerType } from '../../../../user';

export enum CompartmentUserCarrierPermissions {
  DockAllocationAllowed = 'dockAllocationAllowed',
  ForceDockAllocation = 'forceDockAllocation',
  CalendarBasedUliAllocationAllowed = 'calendarBasedUliAllocationAllowed',
}

export enum CompartmentUserListFilterName {
  DockAllocationAllowed = 'dockAllocationAllowed',
  ForceDockAllocation = 'forceDockAllocation',
  CalendarBasedUliAllocationAllowed = 'calendarBasedUliAllocationAllowed',
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  Country = 'country',
  PartnerType = 'partnerType',
}

export const COMPARTMENT_USER_FILTER_TYPE_BY_NAME: Map<CompartmentUserListFilterName, DraggableFilterType> = new Map([
  [CompartmentUserListFilterName.DockAllocationAllowed, DraggableFilterType.DropDownSelect],
  [CompartmentUserListFilterName.ForceDockAllocation, DraggableFilterType.DropDownSelect],
  [CompartmentUserListFilterName.CalendarBasedUliAllocationAllowed, DraggableFilterType.DropDownSelect],
  [CompartmentUserListFilterName.Email, DraggableFilterType.Input],
  [CompartmentUserListFilterName.FirstName, DraggableFilterType.Input],
  [CompartmentUserListFilterName.LastName, DraggableFilterType.Input],
  [CompartmentUserListFilterName.Country, DraggableFilterType.DropDownSearchSelect],
  [CompartmentUserListFilterName.PartnerType, DraggableFilterType.DropDownSelect],
]);

export const COMPARTMENT_FILTER_SELECT_OPTIONS_BY_NAME = new Map<CompartmentUserListFilterName, string[] | Base[]>([
  [CompartmentUserListFilterName.Country, COUNTRIES],
  [CompartmentUserListFilterName.PartnerType, Object.values(UserOwnerType)],
  [CompartmentUserListFilterName.ForceDockAllocation, Object.values(BooleanValues)],
  [CompartmentUserListFilterName.DockAllocationAllowed, Object.values(BooleanValues)],
  [CompartmentUserListFilterName.CalendarBasedUliAllocationAllowed, Object.values(BooleanValues)],
]);

export class CompartmentUserListFiltersModelBase {
  [CompartmentUserListFilterName.DockAllocationAllowed]: boolean = null;
  [CompartmentUserListFilterName.ForceDockAllocation]: boolean = null;
  [CompartmentUserListFilterName.CalendarBasedUliAllocationAllowed]: boolean = null;
  [CompartmentUserListFilterName.Email]: string = null;
  [CompartmentUserListFilterName.FirstName]: string = null;
  [CompartmentUserListFilterName.LastName]: string = null;
  [CompartmentUserListFilterName.Country]: string = null;
  [CompartmentUserListFilterName.PartnerType]: string = null;

  constructor(params?: CompartmentUserListFiltersModelBase) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class CompartmentUserListFilterForm {
  constructor(
    model: CompartmentUserListFiltersModelBase,
    public dockAllocationAllowed: ControlProperty<boolean> = [model.dockAllocationAllowed, []],
    public forceDockAllocation: ControlProperty<boolean> = [model.forceDockAllocation, []],
    public calendarBasedUliAllocationAllowed: ControlProperty<boolean> = [model.calendarBasedUliAllocationAllowed, []],
    public email: ControlProperty<string> = [model.email, []],
    public firstName: ControlProperty<string> = [model.firstName, []],
    public lastName: ControlProperty<string> = [model.lastName, []],
    public country: ControlProperty<string> = [model.country, []],
    public partnerType: ControlProperty<string> = [model.partnerType, []],
  ) {}
}
